export class BaseService {
  protected api: any;
  protected configService: any;
  
  constructor (api: any, configService: any) {
    this.api = api;
    this.configService = configService;
  }
}
